module.exports = __webpack_public_path__ + "static/media/points6_2.d2a03501.png";